import React, {useContext, useState} from "react";
import {Space} from "antd";
import BatchListModal from "@/page-components/detail/BatchList/BatchListModal";
import {DetailContext} from "@/context/detailContext";
import styles from './index.module.less';

const BatchList:React.FC = () => {
  const contextProps = useContext(DetailContext);
  const {data} = contextProps;
  const {title, type,exam_info:{duration}} = data;

  const [visible, setVisible] = useState(false);
  const calcCom = () => {
    if (['fcrp','fcbp','fcjp','fcap'].includes(type)){
      return (
        <Space>
          2天起（每月统一开始<span className={styles.link} onClick={() => {
            setVisible(true);
          }}>查看考试安排</span>）
        </Space>
      )
    }
    return <span>{duration}</span>;
  }

  return (
    <>
      <p className={styles.batchlist}>
        {calcCom()}
      </p>
      <BatchListModal title={title} visible={visible} onClose={() => {
        setVisible(false);
      }}/>
    </>
  )
}
export default BatchList;
